import { makeStyles } from '@fluentui/react-components';

export const useConversationStatusesPanelStyles = makeStyles({
    colourSwatch: {
        backgroundColor: 'attr(data-colour type(<color>), transparent)',
        width: '18px',
        height: '18px',
        display: 'inline-block',
        flexShrink: 0,
        borderRadius: '3px',
        border: '1px solid rgba(0, 0, 0, 0.25)',
    },
});